export const isEnabled = document.querySelector("[name='harmoniexpo-tickets']")?.content === 'enabled'
export const isAdmin = window?.reactPress?.user?.ID > 0
export const shouldShow = isEnabled || isAdmin

export const isLocalHost = window?.location?.hostname === 'localhost'
export const isStaging = window?.location?.hostname.includes('staging')

export const checkoutUrl = isLocalHost ? 'http://localhost:4000/api/checkout' : isStaging ?
    'https://staging-biljett.harmoniexpo.com/api/checkout' : 'https://biljett.harmoniexpo.com/api/checkout'

export const enviro = isLocalHost ? 'local' : isStaging ? 'stage' : 'prod'
